import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user.model';
import { MOCK_USERS, MOCK_PASSWORDS } from '../mock/mock-data';

/**
 * AuthService – Mock implementation.
 * TODO: Replace login() / logout() with Firebase Auth or Supabase Auth calls.
 * The rest of the app only depends on currentUser$ and currentUser, so the
 * swap will be transparent.
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private _currentUser$ = new BehaviorSubject<User | null>(this.loadSession());

  /** Stream of the logged-in user (null = not authenticated). */
  currentUser$: Observable<User | null> = this._currentUser$.asObservable();

  get currentUser(): User | null {
    return this._currentUser$.value;
  }

  get isLoggedIn(): boolean {
    return !!this._currentUser$.value;
  }

  get currentUserSnapshot(): User | null {
    return this._currentUser$.value;
  }

  /**
   * Mock login: finds the user by email in MOCK_USERS.
   * TODO: replace body with: return this.firebaseAuth.signInWithEmailAndPassword(email, password)
   */
  login(email: string, password: string): boolean {
    const user = MOCK_USERS.find(u => u.email === email) ?? null;
    if (!user) return false;
    const expected = MOCK_PASSWORDS[email];
    // If a password is registered, it must match; otherwise accept any password
    if (expected && password !== expected) return false;
    sessionStorage.setItem('mock_user', JSON.stringify(user));
    this._currentUser$.next(user);
    return true;
  }

  logout(): void {
    sessionStorage.removeItem('mock_user');
    this._currentUser$.next(null);
  }

  private loadSession(): User | null {
    try {
      const raw = sessionStorage.getItem('mock_user');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }
}
